import request from "../utils/request";

export function GET_TaskList(token, projectId, payload) {
  return request.get(`/Task/List/${projectId}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_TaskDetail(token, payload) {
  return request.get("/Task", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_Task(token, payload) {
  return request.post("/Task", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function PUT_Task(token, payload) {
  return request.put("/Task", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_Task(token, payload) {
  return request.delete("/Task", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_TaskComments(token, payload) {
  return request.get("/Task/Comment/List", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_TaskComment(token, payload) {
  return request.post("/Task/Comment", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_TaskComment(token, payload) {
  return request.delete("/Task/Comment", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
